import { memo, useState } from 'react';
import { PhoneIcon, PinIcon } from './icons';

/**
 * Hero — centered identity band on the secondary-color → charcoal gradient:
 * circular portrait (monogram fallback), name, title · company, address and
 * phone rows, then the Get in Touch / Call Now buttons. Rows collapse when
 * their data is missing (the condensed mockup).
 */
export const Hero = memo(({ name, title, company, addressLine, phone, photoUrl, monogram, onGetInTouch }) => {
  const [photoOk, setPhotoOk] = useState(true);
  const showPhoto = !!photoUrl && photoOk;
  const showMonogram = !showPhoto && !!monogram;

  return (
    <section className="cw-hero" id="hero">
      <div className="cw-container hero-inner">
        {(showPhoto || showMonogram) && (
          <figure className="hero-portrait reveal-load">
            {showPhoto ? (
              <img src={photoUrl} alt={name} onError={() => setPhotoOk(false)} />
            ) : (
              <figcaption className="hero-monogram">{monogram}</figcaption>
            )}
          </figure>
        )}

        <h1 className="hero-name reveal-load">{name}</h1>

        {(title || company) && (
          <p className="hero-title reveal-load">
            {title}
            {title && company && ', '}
            {company && <em>{company}</em>}
          </p>
        )}

        {addressLine && (
          <p className="hero-meta reveal-load">
            <PinIcon size={14} />
            <span>{addressLine}</span>
          </p>
        )}

        {phone && (
          <p className="hero-meta reveal-load">
            <PhoneIcon size={14} />
            <a href={`tel:${phone.anchor}`}>{phone.label}</a>
          </p>
        )}

        <div className="hero-actions reveal-load">
          <button type="button" className="btn btn-primary btn-lg" onClick={onGetInTouch}>
            Get in Touch
          </button>
          {phone && (
            <a className="btn btn-ghost btn-lg" href={`tel:${phone.anchor}`}>
              <PhoneIcon size={14} />
              Call Now
            </a>
          )}
        </div>
      </div>
    </section>
  );
});
